import type { ArtistContact } from '~/modules/artist-roster/types';

export function sortContacts(contacts: ArtistContact[] | undefined) {
  return contacts?.sort((a, b) => {
    // First compare by title (e.g. - Manager).
    const titleCompare = a.title.localeCompare(b.title);

    if (titleCompare !== 0) {
      return titleCompare;
    }

    // If the titles are the same, compare by full name.
    const aName = `${a.firstName} ${a.lastName}`.toLowerCase();
    const bName = `${b.firstName} ${b.lastName}`.toLowerCase();

    return aName.localeCompare(bName);
  });
}
